export const deepCopy = <T>(object: T): T => {
	if (object === null || typeof object !== 'object') {
		return object;
	}

	if (Array.isArray(object)) {
		return object.map(deepCopy) as T;
	}

	const result: Record<string, unknown> = {};
	const keys = Object.keys(object);

	keys.forEach(key => {
		result[key] = deepCopy((object as Record<string, unknown>)[key]);
	});

	return result as T;
};
